module.exports = __webpack_public_path__ + "img/icon-folder.622d884d.svg";